import Config from './config'
// import Effects from '../effects/effects'
// import Phaser from 'phaser'
import ArcTimer from '../arc-timer/arc-timer'

const dev2 = () => new Promise((resolve, reject) => {
    // Config.scene.input.on('pointerdown', () => {
    //     const {worldX, worldY} = Config.scene.input.activePointer
    //     const x = worldX
    //     const y = worldY
    //
    //     new Effects().scoreAnim({
    //         x,
    //         y,
    //         num: Config.chance.integer({min: 0, max: 240}),
    //         positive: Config.chance.integer({min: 0, max: 1}) === 1,
    //     })
    //     setTimeout(() => {
    //         new Effects().resourceAnim({
    //             x,
    //             y,
    //             num: Config.chance.integer({min: 0, max: 240}),
    //             positive: Config.chance.integer({min: 0, max: 1}) === 1,
    //         })
    //     }, Config.pointAnimDelay)
    // })

    let longPressArc

    Config.scene.input.on('pointerdown', () => {
        const {worldX, worldY} = Config.scene.input.activePointer
        const x = worldX
        const y = worldY

        longPressArc = new ArcTimer({
            alpha: 0.6,
            color: 'cccccc',
            duration: 1000,
            radius: 8,
            lineWidth: 16,
            x,
            y,
        })

        longPressArc.promise
            .then(() => {
                console.log('long press event')
            })
            .catch(() => {})

        longPressArc.graphics.alpha = 0

        setTimeout(() => {
            Config.scene.tweens.add({
                targets: longPressArc.graphics,
                alpha: 1,
                ease: 'Linear',
                duration: 300,
            })
        }, 100)
    })

    Config.scene.input.on('pointerup', ({x, y}) => {
        longPressArc && longPressArc.remove()
    })

    return resolve()
})

export default dev2
